import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./AwardsMedia.css";

import FactoryLicense from "../../Assets/FactoryLicense.jpg";
import IATF_Certificate from "../../Assets/IATF_Certificate.jpg";
import E57_COP from "../../Assets/E57_COP.jpg";
import MediaCoverage1 from "../../Assets/MediaCoverage1.jpg";
import ISO45001 from "../../Assets/ISO45001.jpg";
import ISO9001 from "../../Assets/ISO9001.jpg";
import ISO9004 from "../../Assets/ISO9004.png";
import MSMEAward from "../../Assets/MSMEAward.jpg";
// import MediaCoverage2 from "../../Assets/MediaCoverage2.jpg";

const AwardsMedia = () => {
  return (
    <>
      <Header />

      {/* Banner */}
      <section className="awards-banner">
        <div className="container">
          <h1>Awards , Media & Certificate</h1>
          <p>
            Recognitions, Certifications, and Media Coverage showcasing
            Khodiyar Automotive Glass Pvt. Ltd.'s commitment to quality,
            innovation, safety, and excellence.
          </p>
        </div>
      </section>


   {/* Section */}
<section className="award-section">
  <div className="award-container">
    <div className="award-image">
      <img src={ISO9004} alt="ISO 14001:2015 Certification" />
    </div>

    <div className="award-content">
      <span className="award-tag">Environmental Management</span>
      <h2>ISO 14001:2015 Certification</h2>

      <p>
        Khodiyar Automotive Glass Pvt. Ltd. is certified under ISO 14001:2015,
        the internationally recognized standard for Environmental Management
        Systems (EMS). This certification reflects our commitment to
        environmentally responsible manufacturing practices and sustainable
        business operations.
      </p>

      <p>
        Through effective environmental management, we strive to minimize our
        environmental impact, optimize resource utilization, reduce waste, and
        comply with all applicable environmental regulations while maintaining
        the highest standards of product quality.
      </p>

      <ul>
        <li>Commitment to Sustainable Manufacturing Practices</li>
        <li>Efficient Resource & Energy Management</li>
        <li>Waste Reduction and Pollution Prevention</li>
        <li>Compliance with Environmental Regulations</li>
        <li>Continuous Improvement in Environmental Performance</li>
      </ul>
    </div>
  </div>
</section>
      {/* Section 3 */}
      <section className="award-section">
        <div className="award-container">
          <div className="award-image">
            <img src={ISO45001} alt="ISO 45001 Certification" />
          </div>

          <div className="award-content">
            <span className="award-tag">International Certification</span>
            <h2>ISO 45001:2018 Certification</h2>

            <p>
              Our Occupational Health & Safety Management System is certified
              under ISO 45001:2018, demonstrating our commitment to workplace
              safety, employee well-being, and risk management practices.
            </p>

            <ul>
              <li>Enhanced Workplace Safety</li>
              <li>International Compliance Standards</li>
              <li>Continuous Improvement Culture</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Section 4 */}
      <section className="award-section gray-bg">
        <div className="award-container reverse">
          <div className="award-content">
            <span className="award-tag">Quality Excellence</span>
            <h2>ISO 9001:2015 Certification</h2>

            <p>
              ISO 9001:2015 certification validates our robust quality
              management system, ensuring consistency, reliability, and customer
              satisfaction across all manufacturing processes.
            </p>

            <p>
              Every automotive glass product undergoes stringent quality checks
              to meet national and international standards.
            </p>
          </div>

          <div className="award-image">
            <img src={ISO9001} alt="ISO 9001 Certification" />
          </div>
        </div>
      </section>



      {/* Section 2 */}
      <section className="award-section gray-bg">
        <div className="award-container reverse">
          <div className="award-content">
            <span className="award-tag">Media Coverage</span>
            <h2>Industry Recognition in Leading Publications</h2>

            <p>
              Khodiyar Automotive Glass has been featured in prominent industry
              and regional publications for its rapid growth, manufacturing
              excellence, and contribution to Gujarat's industrial ecosystem.
            </p>

            <p>
              Our continuous investment in technology, innovation, and customer
              satisfaction has helped establish us as a trusted automotive glass
              manufacturer.
            </p>
          </div>

          <div className="award-image">
            <img src={MediaCoverage1} alt="Media Coverage" />
          </div>
        </div>
      </section>



      {/* Section 5 */}
      <section className="award-section">
        <div className="award-container">
          <div className="award-image">
            <img src={MSMEAward} alt="MSME Award" />
          </div>

          <div className="award-content">
            <span className="award-tag">Award Winner</span>
            <h2>Best MSEs Region (North Gujarat) Award 2024-25</h2>

            <p>
              Khodiyar Automotive Glass Pvt. Ltd. was honored by the MSME
              Commissionerate, Government of Gujarat, for outstanding
              performance and contribution to the manufacturing sector.
            </p>

            <p>
              This recognition reflects our dedication to innovation, quality
              manufacturing, and sustainable business growth.
            </p>
          </div>
        </div>
      </section>
           {/* Section 1 */}
      <section className="award-section">
        <div className="award-container">
          <div className="award-image">
            <img src={FactoryLicense} alt="Factory License" />
          </div>

          <div className="award-content">
            <span className="award-tag">Government Approval</span>
            <h2>Factory License & Operational Compliance</h2>

            <p>
              Khodiyar Automotive Glass Pvt. Ltd. is officially licensed by the
              Directorate Industrial Safety & Health, Government of Gujarat.
              This certification confirms our compliance with industrial safety,
              workforce management, and manufacturing regulations.
            </p>

            <ul>
              <li>Government Approved Manufacturing Facility</li>
              <li>Compliance with Industrial Safety Standards</li>
              <li>Authorized Automotive Glass Manufacturing Operations</li>
            </ul>
          </div>
        </div>
      </section>
      <section className="award-section">
        <div className="award-container">
          <div className="award-image">
            <img src={IATF_Certificate} alt="Factory License" />
          </div>

          <div className="award-content">
        <span className="award-tag">Automotive Quality Certification</span>
<h2>IATF 16949:2016 Certification</h2>

<p>
  Khodiyar Automotive Glass Pvt. Ltd. is certified under IATF 16949:2016,
  an internationally recognized quality management standard for the
  automotive industry. The certification covers the manufacture of
  toughened glass and laminated glass.
</p>

<ul>
  <li>Internationally Recognized Automotive Quality Standard</li>
  <li>Manufacturing of Toughened & Laminated Glass</li>
  <li>Consistent Product Quality & Reliable Processes</li>
  <li>Commitment to Automotive Industry Requirements</li>
</ul>
          </div>
        </div>
      </section>


  {/* Section 5 */}
      <section className="award-section">
        <div className="award-container">
          <div className="award-image">
            <img src={E57_COP} alt="MSME Award" />
          </div>

          <div className="award-content">
          <span className="award-tag">Automotive Type Approval</span>
<h2>E57 Automotive Type Approval Certification</h2>

<p>
  Khodiyar Automotive Glass Pvt. Ltd. has received E57 approval from the
  Authority for Homologation of the Republic of San Marino for the
  production of automotive glass components. This approval demonstrates
  compliance with applicable UNECE vehicle regulations and homologation
  requirements.
</p>

<ul>
  <li>E57 Type Approval from the Republic of San Marino</li>
  <li>Compliance with UNECE Vehicle Regulations</li>
  <li>Approved Automotive Glass Components</li>
  <li>Commitment to Product Safety & Compliance</li>
</ul>
          </div>
        </div>
      </section>


  {/* Section 6 */}
      <section className="award-section gray-bg">
        <div className="award-container reverse">
          <div className="award-content">
            <span className="award-tag">Media Spotlight</span>
            <h2>Featured Success Story</h2>

            <p>
              Our achievements have attracted widespread media attention,
              highlighting our journey from a growing enterprise to a trusted
              manufacturer of automotive safety glass solutions.
            </p>

            <p>
              Through innovation, advanced manufacturing practices, and customer
              trust, Khodiyar Automotive Glass continues to set benchmarks in
              the automotive glass industry.
            </p>
          </div>

          {/* <div className="award-image">
            <img src={MediaCoverage2} alt="Media Spotlight" />
          </div> */}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default AwardsMedia;
